const state = {
  list: [],
  list_for_product: {},
  output: {},
  edit_output: {}
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  list_for_product: (state) => {
    return state.list_for_product || {};
  },
  connected: (state, getters) => {
    return getters.list_for_product.connected || [];
  },
  available: (state, getters) => {
    return getters.list_for_product.available || [];
  },
  output: (state) => {
    return state.output || {};
  },
  edit_output: (state) => {
    return state.edit_output || {};
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_LIST_FOR_PRODUCT(state, list) {
    state.list_for_product = list;
  },

  SET_OUTPUT(state, output) {
    state.output = output;
    state.edit_output = output;
  },
  EDIT_OUTPUT(state, item) {
    state.edit_output = item;
  }
};

const actions = {
  resetList({ commit }) {
    commit('SET_LIST', []);
    commit('SET_LIST_FOR_PRODUCT', []);
  },
  getList({ commit }, productId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(productId ? `outputs/getForProduct?id=${productId}` : 'outputs/getAll')
        .then((response) => {
          if (productId) {
            commit('SET_LIST_FOR_PRODUCT', response.data);
          } else {
            commit('SET_LIST', response.data);
          }
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`outputs/get?id=${id}`)
        .then((response) => {
          commit('SET_OUTPUT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  set({ commit }, item) {
    commit('SET_OUTPUT', item);
  },
  edit({ commit }, item) {
    commit('EDIT_OUTPUT', item);
  },
  save({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('outputs/save', item)
        .then((response) => {
          commit('SET_OUTPUT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  connect({}, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('outputs/connect', item)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  disconnect({}, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('outputs/disconnect', item)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  setDefault({}, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('outputs/setDefault', item)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
